/** Construtores com defaults válidos. Nenhum item nasce em estado inconsistente. */
import { createId } from './ids.js';
import { FPS_30 } from './time.js';
export function defaultTransform() {
    return { x: 0, y: 0, scale: 1, rotation: 0, opacity: 1, anchorX: 0.5, anchorY: 0.5 };
}
export function defaultCrop() {
    return { top: 0, right: 0, bottom: 0, left: 0 };
}
export function defaultTextProps(content = 'Texto') {
    return {
        content,
        fontFamily: 'Inter',
        fontSize: 72,
        fontWeight: 700,
        italic: false,
        color: '#FFFFFF',
        align: 'center',
        lineHeight: 1.2,
        letterSpacing: 0,
        stroke: { color: '#000000', width: 0 },
        shadow: undefined,
        background: undefined,
        animationIn: 'none',
        animationOut: 'none',
    };
}
export function defaultCaptionProps() {
    return {
        words: [],
        style: 'karaoke',
        fontFamily: 'Inter',
        fontSize: 64,
        fontWeight: 800,
        color: '#FFFFFF',
        activeColor: '#FFD400',
        highlightColor: '#22D3EE',
        stroke: { color: '#000000', width: 6 },
        shadow: { color: '#000000CC', x: 0, y: 4, blur: 8 },
        background: undefined,
        align: 'center',
        positionY: 0.78,
        maxWordsPerLine: 5,
        uppercase: false,
    };
}
export function createItem(input) {
    const item = {
        id: input.id ?? createId('itm'),
        kind: input.kind,
        start: input.start,
        duration: input.duration,
        source: input.source,
        speed: 1,
        reverse: false,
        preservePitch: true,
        transform: defaultTransform(),
        crop: defaultCrop(),
        volume: 1,
        muted: false,
        fadeIn: 0,
        fadeOut: 0,
        effects: [],
        keyframes: [],
        locked: false,
        label: input.label,
        meta: input.meta ?? {},
    };
    if (input.kind === 'text')
        item.text = defaultTextProps();
    if (input.kind === 'caption')
        item.caption = defaultCaptionProps();
    return item;
}
const TRACK_HEIGHTS = {
    video: 72,
    image: 56,
    overlay: 56,
    adjustment: 40,
    text: 44,
    caption: 44,
    audio: 60,
    music: 56,
    sfx: 44,
};
export function createTrack(input) {
    return {
        id: input.id ?? createId('trk'),
        kind: input.kind,
        name: input.name ?? defaultTrackName(input.kind, input.index),
        index: input.index,
        locked: false,
        hidden: false,
        muted: false,
        solo: false,
        height: TRACK_HEIGHTS[input.kind],
        volume: 1,
        items: input.items ?? [],
    };
}
function defaultTrackName(kind, index) {
    const prefix = {
        video: 'V',
        image: 'IMG',
        overlay: 'OVL',
        adjustment: 'ADJ',
        text: 'TXT',
        caption: 'CC',
        audio: 'A',
        music: 'MUS',
        sfx: 'SFX',
    };
    return `${prefix[kind]}${index + 1}`;
}
export function createMarker(time, name = 'Marcador', color = '#38BDF8') {
    return { id: createId('mrk'), time, name, color };
}
export function createSequence(input) {
    const tracks = input.withDefaultTracks !== false
        ? [
            createTrack({ kind: 'audio', index: 0, name: 'A1' }),
            createTrack({ kind: 'video', index: 1, name: 'V1' }),
            createTrack({ kind: 'text', index: 2, name: 'TXT1' }),
            createTrack({ kind: 'caption', index: 3, name: 'CC1' }),
        ]
        : [];
    return {
        id: input.id ?? createId('seq'),
        projectId: input.projectId,
        name: input.name ?? 'Sequência principal',
        frameRate: input.frameRate ?? FPS_30,
        width: input.width ?? 1920,
        height: input.height ?? 1080,
        sampleRate: input.sampleRate ?? 48000,
        backgroundColor: '#000000',
        tracks,
        markers: [],
        revision: 0,
    };
}
//# sourceMappingURL=factory.js.map